import axios from 'axios'
import { config } from './config'
import {store} from "@/store";

const apiUrl = config.$api_url

export default {
    get(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/sites', data)
            .then(response => response.data)
    },
    getSitesForBankAccount(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/sites-bank-account', data)
            .then(response => response.data)
    },
    detail(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/detail-site', data)
            .then(response => response.data)
    },
    add(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/add-site', data)
            .then(response => response.data)
    },
    edit(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-site', data)
            .then(response => response.data)
    },
    remove(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/remove-site', data)
            .then(response => response.data)
    },
    changeStatus(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/change-status-site', data)
            .then(response => response.data)
    },
    changeSecrets(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/new-secret-key', data)
            .then(response => response.data)
    },

    getUsers(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/site-users', data)
            .then(response => response.data)
    },
    userDetail(data) {
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/detail-site-user', data)
            .then(response => response.data)
    },
    addUser(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
            return axios.post(apiUrl + '/admin/add-site-user', data)
            .then(response => response.data)
    },
    editUser(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/edit-site-user', data)
            .then(response => response.data)
    },
    changeUserStatus(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/change-status-site-user', data)
            .then(response => response.data)
    },
    removeUser(data){
        axios.defaults.headers.common['x-access-token'] = `${store.getters.token}`
        return axios.post(apiUrl + '/admin/remove-site-user', data)
            .then(response => response.data)
    },

}